import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useSnackbar } from 'v3/components/Snackbar';
import Text from 'v3/components/Text';

import api from 'services/api';

import { useCurrentUser } from 'hooks';
import Details from '../Details';
import Register from '../Register';

import { RouteProvider } from './context';
import { chargingMethods } from '../../../utils/chargingMethods';

function getInitialRouteState(user) {
  return {
    product_type: user?.company.product_type,
  };
}

function RouteSharedContent({ routeId }) {
  const currentUser = useCurrentUser();
  const [route, setRoute] = useState(() => getInitialRouteState(currentUser));
  const [prevRoute, setPrevRoute] = useState(route);
  const [isFetching, setFetching] = useState(false);
  const [errors, setErrors] = useState({});
  const [minimumFreightTableItem, setMinimumFreightTableItem] = useState({});
  const snackbar = useSnackbar();

  function showSnackbar(text, options) {
    snackbar.show(<Text>{text}</Text>, options);
  }

  useEffect(() => {
    let active = true;

    async function fetchRoute() {
      try {
        setFetching(true);
        const response = await api.get(`v3/route/${routeId}`);
        if (!active) return;

        setRoute({
          ...response.data,
          origin: response.data.origin,
          product: {
            name: `${response.data.product?.name} - ${response.data.product?.productType?.name}`,
            value: response.data.product?.id,
          },
          charge_type: chargingMethods[response.data?.charge_type - 1],
          parameters: JSON.parse(response.data.parameters),
        });
        setPrevRoute(response.data);
      } catch (ex) {
        if (!active) return;

        showSnackbar('Não foi possível carregar essa rota', {
          type: 'error',
        });
      } finally {
        if (active) {
          setFetching(false);
        }
      }
    }

    if (routeId) {
      fetchRoute();
      return () => {
        active = false;
      };
    }

    return () => {
      active = false;
    };
  }, [routeId]);

  function setData(data) {
    setRoute((prev) => {
      const nextData = typeof data === 'function' ? data(prev) : data;
      return { ...prev, ...nextData };
    });
  }

  function updatePrevRoute() {
    setPrevRoute(route);
  }

  function handleCancel() {
    setRoute(prevRoute);
  }

  return (
    <RouteProvider
      value={{
        data: route,
        setData,
        isFetching,
        errors,
        setErrors,
        showSnackbar,
        handleCancel,
        updatePrevRoute,
        prevRoute,
        minimumFreightTableItem,
        setMinimumFreightTableItem,
      }}
    >
      {routeId ? <Details /> : <Register />}
    </RouteProvider>
  );
}

export default function RouteShared() {
  const params = useParams();
  const routeKey = params.id || 'create';

  return <RouteSharedContent key={routeKey} routeId={params.id} />;
}
